module.exports = __webpack_public_path__ + "img/ttshop_dpj1.4e89bccf.svg";